import get from 'lodash.get';
import { createSelector } from 'src/universal/redux/utils';
import {
  getActivePageName,
  getPageLabels,
  getPageLevelDtmHash
} from 'src/universal/redux/page';
import { isCardMemberGCS } from 'src/universal/redux/userType';
import { hasPznDataArrived, getPznPageData } from 'src/universal/redux/pznData';
import { buildUpdatedCtaUrl } from 'src/universal/utils/orchestraUtils';
import convertToAsset from 'src/universal/utils/titleToDtmAsset';
import {
  DEFAULT_OFFER,
  DEFAULT_PRODUCT,
  DEFAULT_CTA
} from 'src/universal/utils/orchestraDefaultEventAssetParts';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import {
  getCardMemberFirstName,
  hasMemberInfoArrived
} from 'src/universal/redux/cardMemberInfo';
import { getPageFeatureFlags } from 'src/universal/redux/page';

const NAME_PLACEHOLDER = '*First Name*,';

/* eslint-disable max-params */
/* eslint-disable max-statements */
/* eslint-disable complexity */
export const getBannerPznData = createSelector(
  [
    isCardMemberGCS,
    hasPznDataArrived,
    getPznPageData,
    getPageLabels,
    getPageLevelDtmHash,
    getActivePageName,
    hasMemberInfoArrived,
    getCardMemberFirstName,
    getPageFeatureFlags
  ],
  (
    isCm,
    pznDataArrived,
    pznPageData,
    labels,
    dtmHash,
    pageName,
    cmInfoArrived,
    firstName,
    featureFlags
  ) => {
    let showBanner = false;
    let content = {};

    const bannerData =
      pageName === 'businessHub' ? pznPageData.cmB2B_Banner : pznPageData.cmBanner;

    let impressionDtm = {};
    let ctaClickDtm = {};

    if (
      isCm &&
      (featureFlags || {}).showCmPznBanner &&
      pznDataArrived &&
      cmInfoArrived &&
      !!bannerData
    ) {
      showBanner = true;
      content = bannerData;
      const ctaObj = get(content, 'links[0]') || null;
      const dynamicAssetList = [];
      if (ctaObj) {
        // we are mutating the link object inside content.
        ctaObj.url = buildUpdatedCtaUrl(content.clickTrackingUrl, ctaObj, true);
        dynamicAssetList.push(convertToAsset(ctaObj.text || DEFAULT_CTA, '_'));
      } else {
        dynamicAssetList.push(DEFAULT_CTA);
      }

      const cardAsset = (content.assets || []).find(a => a.type === 'cardArt');
      if (cardAsset && cardAsset.shortName) {
        dynamicAssetList.push(cardAsset.shortName);
      } else {
        dynamicAssetList.push(DEFAULT_PRODUCT);
      }

      dynamicAssetList.push(content.offerId || DEFAULT_OFFER);
      const dynamicAssetVal = dynamicAssetList.join('-');

      impressionDtm = { ...(dtmHash.cmBannerImpression || {}) };
      impressionDtm.eventAsset = replaceStringWithVars({
        varsObject: {
          dynamicAsset: dynamicAssetVal
        },
        string: impressionDtm.eventAsset
      });

      ctaClickDtm = { ...(dtmHash.cmBannerCtaClick || {}) };
      ctaClickDtm.eventAsset = replaceStringWithVars({
        varsObject: {
          dynamicAsset: dynamicAssetVal
        },
        string: ctaClickDtm.eventAsset
      });

      const tncLinks = content.tncLinks || {};
      Object.keys(tncLinks).forEach(tncKey => {
        const itemDtm = { ...(dtmHash[`cmBannerTnC_${tncKey}`] || {}) };
        itemDtm.eventAsset = replaceStringWithVars({
          varsObject: {
            dynamicAsset: dynamicAssetVal
          },
          string: itemDtm.eventAsset
        });
        tncLinks[tncKey].dtm = itemDtm;
      });

      if (firstName) {
        content.header = String(content.header).replace(
          NAME_PLACEHOLDER,
          `${firstName},`
        );
      } else {
        const tmpStr = String(content.header)
          .replace(NAME_PLACEHOLDER, '')
          .trimStart();
        content.header = `${tmpStr[0].toUpperCase()}${tmpStr.substring(1)}`;
      }
    }

    return {
      content,
      labels,
      showBanner,
      impressionDtm,
      ctaClickDtm,
      maxContentWidth: pageName === 'businessHome' ? '1245px' : '985px'
    };
  }
);

export const isCmPznBannerRenderable = createSelector(
  [
    isCardMemberGCS,
    hasPznDataArrived,
    hasMemberInfoArrived,
    getPznPageData,
    getActivePageName,
    getPageFeatureFlags
  ],
  (isCm, pznDataArrived, cmInfoArrived, pznPageData, pageName, featureFlags) => {
    if (isCm && featureFlags?.showCmPznBanner && pznDataArrived && cmInfoArrived) {
      const bannerData =
        pageName === 'businessHub' ? pznPageData.cmB2B_Banner : pznPageData.cmBanner;

      return { isCm, renderable: !!bannerData };
    }

    return { isCm, renderable: false };
  }
);
